import React from 'react'
// libs
import { Virtuoso } from 'react-virtuoso'
// view components
import Footer from './components/Footer'
import RisksHeader from '../RiskHeader'
// components
import RiskContainer from 'components/PageComponents/Risks/Register/components/RiskView/components/RisksContainer/components/RiskContainer'
// types
import { IRisk } from 'types/graphql'
// views
import { Container } from '../../views'
import { EmptyPlaceholder, GlobalStyles } from './views'

const OVERSCAN = {
  main: 1,
  reverse: 1
}

interface Props {
  risks: IRisk[]
  editRisk: (risk: IRisk) => () => void
  loadMore: (page: number) => Promise<void>
  isLoading: boolean
  totalCount: number
  deleteRisk: (id: string) => () => Promise<void>
  isScheduled: boolean
}

const RisksInfinityList: React.FC<Props> = ({
  risks,
  editRisk,
  loadMore,
  isLoading,
  totalCount,
  deleteRisk,
  isScheduled
}) => {
  const [page, setPage] = React.useState(0)
  const [loading, setLoading] = React.useState(false)

  const onLoadMore = async () => {
    setLoading(true)

    const nextPage = page + 1

    await loadMore(nextPage)

    setPage(nextPage)
    setLoading(false)
  }

  return (
    <Container className='riskViewContainer' $isInfinityList>
      <GlobalStyles />
      <Virtuoso
        topItemCount={1}
        overscan={OVERSCAN}
        defaultItemHeight={48}
        totalCount={risks.length + 1}
        components={{
          Footer: () => <Footer loading={loading} loadMore={onLoadMore} hasMore={risks.length < totalCount} />,
          EmptyPlaceholder: () => (isLoading ? null : <EmptyPlaceholder>No data yet!</EmptyPlaceholder>)
        }}
        itemContent={(index) => {
          if (index === 0) {
            return <RisksHeader isScheduled={isScheduled} />
          }

          const risk = risks[index - 1]

          return (
            <RiskContainer
              risk={risk}
              key={risk.id}
              isScheduled={isScheduled}
              editRisk={editRisk(risk)}
              deleteRisk={deleteRisk(risk.id)}
            />
          )
        }}
      />
    </Container>
  )
}

export default RisksInfinityList
